<h3 class="sr-only">Explore Products</h3>
<ul class="ui-grid-cols-2 ui-gap-xl ui-grid ui-grid-rows-2">
    <li *ngFor="let product of exploreProductList"
        class="explore-product-card border border-radius-m">
        <a target="_blank" href="{{product.url}}">
            <global-home-icon [svg]="product.icon" [size]="36">
            </global-home-icon>
            <div>
                <div class="product">
                    <h4>{{product.name}}</h4>
                    <global-home-icon class="icon" [svg]="newTabSvg" [size]="14"></global-home-icon>
                </div>
                <div class="description text-size-m text-darker">
                    {{product.description}}
                </div>
            </div>
        </a>
    </li>
</ul>
